import {Action, Store} from 'redux';

import {SESSION_STORAGE_NAMESPACE} from 'types/SessionNamespace';
import {pickPaths} from 'utils/trees';

const pathsToSync = [
  ['documents', 'documentsViewed'],
  ['messages', 'messagesViewed']
];

/**
 * Syncs redux state with sessionStorage
 */
const sessionStorageMiddleware = (store: Store) => (next: (action: Action) => object) => (action: Action) => {
  const result = next(action);
  const state = store.getState();

  const storedState = pickPaths(pathsToSync, state);
  window.sessionStorage.setItem(SESSION_STORAGE_NAMESPACE, JSON.stringify(storedState));

  return result;
};

export default sessionStorageMiddleware;
